<template>
  <div class="m-home">
    <chain-info></chain-info>
    <k-line :showY="false"></k-line>
    <view-block :ListLength="4"></view-block>
    <view-tx :ListLength="4"></view-tx>
  </div>
</template>

<script>
import ChainInfo from "./ChainInfo";
import KLine from "./Kline";
import ViewBlock from "./ViewBlock";
import ViewTx from "./ViewTx";
import homeBase from "@/mixins/Home/home.js";
export default {
  mixins: [homeBase],
  components: {
    ChainInfo,
    KLine,
    ViewBlock,
    ViewTx
  }
};
</script>

<style lang="scss" scoped>
.m-home {
}
</style>

